import { render, staticRenderFns } from "./taskInfo.vue?vue&type=template&id=4000c4be&scoped=true"
import script from "./taskInfo.vue?vue&type=script&lang=js"
export * from "./taskInfo.vue?vue&type=script&lang=js"
import style0 from "./taskInfo.vue?vue&type=style&index=0&id=4000c4be&prod&lang=scss&scoped=true"
import style1 from "./taskInfo.vue?vue&type=style&index=1&id=4000c4be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4000c4be",
  null
  
)

export default component.exports